"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiCallHandler = exports.get = exports.post = exports.logError = exports.textNewLines = exports.truncate = exports.convertFileToBase64 = exports.mapRandomKey = void 0;
const react_1 = __importDefault(require("react"));
const axios_1 = __importDefault(require("axios"));
const lodash_1 = require("lodash");
function mapRandomKey() {
    return (0, lodash_1.random)(0, 10000000);
}
exports.mapRandomKey = mapRandomKey;
function convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
}
exports.convertFileToBase64 = convertFileToBase64;
function truncate(str, length = 200) {
    return (str === null || str === void 0 ? void 0 : str.length) > length ? (str === null || str === void 0 ? void 0 : str.substring(0, length)) + "....." : str;
}
exports.truncate = truncate;
function textNewLines(str) {
    return str === null || str === void 0 ? void 0 : str.split('\n').map((str, index) => react_1.default.createElement("p", { key: index }, str));
}
exports.textNewLines = textNewLines;
function logError(error, sourceName = null) {
    if (sourceName)
        console.log('error from: ', sourceName);
    if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
    }
    else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
    }
    else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
    }
    console.log(error.stack);
}
exports.logError = logError;
function post(url, params = null, callerIdentifier = null, setData = null) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios_1.default.post(url, params);
            if (setData)
                setData(response.data);
            if (callerIdentifier)
                console.log(callerIdentifier, response.data);
            return response;
        }
        catch (error) {
            logError(error, callerIdentifier);
        }
    });
}
exports.post = post;
function get(url, params = null, callerIdentifier = null, setData = null) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield axios_1.default.get(url, params);
            if (setData)
                setData(response.data);
            if (callerIdentifier)
                console.log(callerIdentifier, response.data);
            return response;
        }
        catch (error) {
            logError(error, callerIdentifier);
        }
    });
}
exports.get = get;
function ApiCallHandler(ApiEndpoint, setData, Identifier, logData = false) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield ApiEndpoint();
            if (setData)
                setData(response.data);
            if (Identifier && logData)
                console.log(Identifier + ':', response.data);
            return response;
        }
        catch (error) {
            logError(error, Identifier);
            throw error;
        }
    });
}
exports.ApiCallHandler = ApiCallHandler;
